var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { PRIVILEGES } from '@lucidlink/dto/validation';
import { useLucidSdk } from '#context';
import { toCurrentMemberViewModel, } from '#models';
// TODO: https://lucidlink.atlassian.net/browse/LUCID-22930
import { CurrentMemberKeyFactory } from '../../query-key-factories';
import { canFetchWorkspaceData } from '../../services';
import { useGetWorkspaceLoginStatus } from './useGetWorkspaceLoginStatus';
export const currentMemberByWorkspaceIdQueryFactory = ({ lucidSdk, workspaceId, }) => ({
    queryKey: CurrentMemberKeyFactory.byWorkspace(workspaceId),
    queryFn: async () => {
        const { filespaceAdminFor, privileges, ...currentMemberData } = await lucidSdk
            .workspaceClient(workspaceId)
            .memberManagement()
            .getCurrentMember();
        return {
            ...currentMemberData,
            privileges: Object.fromEntries(PRIVILEGES.map((privilege) => [
                privilege,
                privileges.includes(privilege),
            ])),
            filespaceAdminFor: filespaceAdminFor === 'all'
                ? 'all'
                : Object.fromEntries((filespaceAdminFor ?? []).map(({ filespaceId }) => [
                    filespaceId,
                    true,
                ])),
        };
    },
    select: toCurrentMemberViewModel,
});
export function useCurrentMemberByWorkspaceId(workspaceId) {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { query: { data: workspaceLoginStatus, isFetching }, } = useGetWorkspaceLoginStatus(workspaceId);
    const query = useQuery({
        ...currentMemberByWorkspaceIdQueryFactory({ lucidSdk, workspaceId }),
        enabled: !isFetching && canFetchWorkspaceData(workspaceLoginStatus),
        networkMode: 'always',
    });
    return { query };
}
_react_refresh_temp_1(useCurrentMemberByWorkspaceId, "lLi55lVADzcpJwEo/daHyb1gyi8=", false, () => [useLucidSdk, useGetWorkspaceLoginStatus, useQuery]);
